export const GROUP_API = "/group";
export const HOME_API = "/home";
export const MEMBERS_API = "/members";
export const REPORT_API = "/report";
export const OVERVIEW_API = "/overview";
export const DASHBOARD_API = "/dashboard";
export const DIVIDE_API = "/equipment/divide";
